// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1K3LS","inner":"Footer_inner__3Vwk1"};